'use strict';

var SeasonalityCalendarGridsDirective = function SeasonalityCalendarGridsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-calendar-grids.html'),
    requires: '^rmSeasonalityPanel',
    scope: false
  };
};
SeasonalityCalendarGridsDirective.$inject = [];
module.exports = SeasonalityCalendarGridsDirective;